<template>
  <!-- <div class='EnbNave0302' :style="{backgroundImage: `url('${Prefes.Model03Theme02Image ? api + Prefes.Model03Theme02Image.img : ''}')`}"> -->
  <div class='EnbNave0302' :style="{ backgroundColor: Prefes.nave.corBackground }">
    <div class="cont-nave">
      <div class="cont-logo">
        <enb-logo/>
      </div>
      <div class="cont-tel-link-search">
        <div class="cont-tel-link">
          <div class="cont-tel">
            <whats-icon :color="Prefes.nave.corFont" @click="toMsg"/>
            <div @click="toMsg" class="tel" style="padding-left: 5px;"
            :style="{
              'color': Prefes.nave.corFont,
              'font-family': Prefes.nave.font,
              fontStyle: parseInt(Prefes.nave.fontStyle) ? 'italic' : '',
              fontWeight: parseInt(Prefes.nave.fontBold) ? 'bold' : '',
              textDecoration: parseInt(Prefes.nave.textDecoration) ? 'underline' : '',
              fontSize: Prefes.nave.fontHeight + 'px'
            }"
            >
              {{ `(${Empresa.whatsapp.substr(0 , 2)}) ${Empresa.whatsapp.substr(2 , 5)}-${Empresa.whatsapp.substr(7 , 4)}` }}
            </div>
          </div>
          <div class="cont-link">
            <enb-nave-link0302
            v-for="(link, key) in Categorias.length ? Categorias.filter(c  => c.name !== '') : [{ name: 'Imóveis', icon: 'MapIcon', link: '' }]"
            :key="key"
            :data="link"
            :color="color"
            />
          </div>
        </div>
        <div class="cont-search">
          <search-icon :color="Prefes.nave.corFont" @click="SetModal01({ component: 'EnbSearch', active: true })"/>
          <user-icon :color="Prefes.nave.corFont" v-if="!Object.keys(Profile).length" @click="SetModal01({ component: 'EnbLogin', active: true })"/>
          <user-icon :color="Prefes.nave.corFont" v-if="Object.keys(Profile).length" @click="toProfile"/>
        </div>
      </div>
    </div>
    <!-- <div class="cont-slogan">
      {{ Prefes.Model03Theme02Slogan ? Prefes.Model03Theme02Slogan.text : '' }}
    </div> -->
    <!-- <div class="cont-btn">
      <button @click="toNews" :style="{ '--hover-bg': color, 'border': `thin solid ${color}`, 'color': color, '--out-color': Prefes.nave.corFont }">Ver últimas novidades</button>
    </div> -->
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import EnbLogo from './EnbLogo'
import WhatsIcon from '../Icons/WhatsIcon'
import EnbNaveLink0302 from './EnbNaveLink0302'
import UserIcon from '../Icons/UserIcon'
import SearchIcon from '../Icons/SearchIcon'
import api from '@/mixins/api'
export default {
  name: 'EnbNave0302',
  mixins: [api],
  components: { EnbLogo, WhatsIcon, EnbNaveLink0302, UserIcon, SearchIcon },
  computed: {
    ...mapGetters(['Empresa', 'Categorias', 'Profile', 'Prefes']),
    color () {
      return this.Prefes.nave.corBackground
    }
  },
  methods: {
    ...mapActions(['GetCategory', 'SetModal01']),
    toProfile () {
      // document.getElementById('content').scrollIntoView({ 
      //   behavior: "smooth",
      //   block: "start"
      // })
      this.$router.push('/profile')
    },
    toNews () {
      // document.getElementById('content').scrollIntoView({ 
      //   behavior: "smooth",
      //   block: "start"
      // })
    },
    toMsg () {
      let msg = `Oi tudo bom%3F+ Gostaria de saber mais sobre o imóvel`
      window.location.replace(`https://wa.me/55${this.Empresa.whatsapp}?text=${msg}`)
    }
  },
  created () {
    this.GetCategory()
  }
}
</script>

<style scoped>
.EnbNave0302 {
  width: 100%;
  height: 220px;
  /* background-color: rgba(0, 0, 0, 0.5);
  background-blend-mode: multiply;
  background-attachment: fixed;
  background-size: 100% 100%;
  background-position: center; */
}

.cont-nave {
  width: 80%;
  height: 200px;
  margin: auto;
  display: flex;
}

.cont-logo {
  width: 180px;
  height: 100%;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  background-color: #FFFFFF;
}

.cont-tel-link-search {
  display: flex;
  width: 85.5%;
}

.cont-tel-link {
  width: 80%;
  height: 100%;
}

.cont-tel {
  display: flex;
  text-align: left;
  padding-left: 2%;
  align-items: center;
  height: 20%;
  color: #FFFFFF;
}

.tel {
  cursor: pointer;
}

.cont-link {
  display: flex;
  height: 80%;
  align-items: center;
  padding-left: 2%;
}

.cont-search {
  width: 20%;
  padding: 1%;
  display: flex;
  justify-content: end;
}

.cont-slogan {
  font-family: 'MontSerrat';
  font-size: 60px;
  line-height: 60px;
  font-weight: 700;
  padding: 5%;
  color: #FFFFFF;
}

.cont-btn button {
  border: thin solid red;
  background-color: transparent;
  color: red;
  padding: 1.5%;
  border-radius: 5px;
  font-size: 20px;
  cursor: pointer;
  animation: Out 0.7s forwards;
}

.cont-btn button:hover {
  animation: In 1s forwards;
}


@keyframes In {
  0% {
    background-color: transparent;
  }
  100% {
    background-color: var(--hover-bg);
    color: var(--out-color);
  }
}
@keyframes Out {
  0% {
    background-color: var(--hover-bg);
  }
  100% {
    background-color: transparent;
  }
}

@media (max-width: 500px) {
  .EnbNave0302 {
    display: none;
  }
}
</style>
